
  import { defineComponent, ref } from 'vue';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import moment from 'moment';
  import { reinitializeComponents } from '@/core/plugins/keenthemes';

  export default defineComponent({
    name: 'estimator-filter-widgets',
    emit: ['filter-selected-estimator', 'reset'],
    components: {},
    async setup(props, { emit }) {
      const { t, te } = useI18n();
      const store = useStore();
      const estimatorFilterValue = await store.getters.estimatorFilterValue;
      const selectedItems = ref<any>({
        dateFrom: estimatorFilterValue.dateFrom
          ? estimatorFilterValue.dateFrom
          : '',
        dateTo: estimatorFilterValue.dateTo ? estimatorFilterValue.dateTo : '',
      });
      console.log(selectedItems);
      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      const onSubmit = () => {
        if (selectedItems.value.dateFrom) {
          selectedItems.value.dateFrom = moment(
            selectedItems.value.dateFrom
          ).format('YYYY-MM-DD');
        }
        if (selectedItems.value.dateTo) {
          selectedItems.value.dateTo = moment(
            selectedItems.value.dateTo
          ).format('YYYY-MM-DD');
        }
        emit('filter-selected', selectedItems);
      };

      const onReset = () => {
        selectedItems.value = {
          dateFrom: '',
          dateTo: '',
        };
        emit('reset', selectedItems.value);
      };
      reinitializeComponents();

      return {
        onSubmit,
        onReset,
        selectedItems,
        translate,
      };
    },
  });
